<ebw-monorepo-sidebar-header [icon]="'maps_home_work'" [title]="'map.sidebar.raccordo-cavo.title'" [isSvg]="false"
  [isOutline]="false">
</ebw-monorepo-sidebar-header>

<div class="info-box info-fiber">
  <mat-icon class="info-box__icon">info_outline</mat-icon>
  <div class="info-box__text">{{'map.sidebar.raccordo-cavo.info_section' | translate}}</div>
</div>

<div *ngIf="filtersForm">
  <form class="d-flex flex-column mt-3" [formGroup]="filtersForm">


    <!-- <div class="form-group row">
      <mat-form-field class="col mt-2" appearance="outline">
        <mat-label> {{ 'map.sidebar.raccordo-cavo.building_name' | translate }}</mat-label>
        <input matInput formControlName="building_name"/>
      </mat-form-field>
    </div> -->
    <div class="form-group row">
      <mat-form-field class="col mt-2" appearance="outline">
        <mat-label>{{ 'map.sidebar.raccordo-cavo.building_name' | translate }}</mat-label>
        <input matInput
              formControlName="building_name"
              [matAutocomplete]="autoEdificio"
              autocomplete="off"/>
        <mat-autocomplete #autoEdificio="matAutocomplete"
                          (optionSelected)="onBuildingSelected($event.option.value)">
          <mat-option *ngFor="let opt of buildingNameSuggestions" [value]="opt">
            {{ opt }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>


    <div class="form-group row">
      <mat-form-field class="col mt-2" appearance="outline">
        <mat-label>{{ 'map.sidebar.raccordo-cavo.building_alias' | translate }}</mat-label>
        <input matInput formControlName="building_alias">
      </mat-form-field>
    </div>


    <div class="form-group row">
      <mat-form-field class="col mt-2" appearance="outline">
        <mat-label>GAT SEDE</mat-label>
        <input matInput formControlName="gat_sede">
      </mat-form-field>
    </div>

  </form>
  <div class="mt-2">
    <button mat-flat-button color="primary" (click)="search()" [disabled]="filtersForm.invalid" style="float: right">
      {{ 'common.search' | translate }}
    </button>
    <button mat-flat-button (click)="clearFilter()" style="float: right">
      Reset
    </button>
  </div>

</div>
